module.exports = __webpack_public_path__ + "img/vri-dark.3ac633ec.svg";